import { createSvgIcon } from "@mui/material";

export const UpscaleImageIcon = createSvgIcon(
  <svg viewBox="0 0 18 18" fill="currentColor">
    <path
      d="M3.4375 0H4.375C4.6875 0 5 0.3125 5 0.625C5 0.976562 4.6875 1.25 4.375 1.25H3.4375C2.22656 1.25 1.25 2.26562 1.25 3.4375V4.375C1.25 4.72656 0.9375 5 0.625 5C0.273438 5 0 4.72656 0 4.375V3.4375C0 1.5625 1.52344 0 3.4375 0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.625 6.25C0.64344 6.25 0.66188 6.25109 0.680255 6.2532C0.703219 6.25108 0.726483 6.25 0.75 6.25H7.85C9.72777 6.25 11.25 7.77223 11.25 9.65V16.75C11.25 16.7735 11.2489 16.7968 11.2468 16.8197C11.2489 16.8381 11.25 16.8566 11.25 16.875C11.25 17.2266 10.9375 17.5 10.625 17.5H10.5017L10.5 17.5H3.4C1.52223 17.5 0 15.9778 0 14.1V6.875C0 6.5625 0.273438 6.25 0.625 6.25ZM8.77138 13.751V9.35643C8.77138 9.02291 8.4771 8.72864 8.14359 8.72864H3.74905C3.39592 8.72864 3.12126 9.02291 3.12126 9.35643C3.12126 9.70956 3.39592 9.98422 3.74905 9.98422H6.61335L2.67004 13.9471C2.415 14.1826 2.415 14.5946 2.67004 14.83C2.90546 15.085 3.31745 15.085 3.55287 14.83L7.51579 10.8867V13.751C7.51579 14.1041 7.79045 14.3787 8.14359 14.3787C8.4771 14.3787 8.77138 14.1041 8.77138 13.751Z"
      fill="currentColor"
    />
    <path
      d="M17.5 6.875C17.5 6.5625 17.1875 6.25 16.875 6.25C16.5234 6.25 16.25 6.5625 16.25 6.875V10.625C16.25 10.9766 16.5234 11.25 16.875 11.25C17.1875 11.25 17.5 10.9766 17.5 10.625V6.875Z"
      fill="currentColor"
    />
    <path
      d="M16.875 5C16.5234 5 16.25 4.72656 16.25 4.375V3.4375C16.25 2.26562 15.2344 1.25 14.0625 1.25H13.125C12.7734 1.25 12.5 0.976562 12.5 0.625C12.5 0.3125 12.7734 0 13.125 0H14.0625C15.9375 0 17.5 1.5625 17.5 3.4375V4.375C17.5 4.72656 17.1875 5 16.875 5Z"
      fill="currentColor"
    />
    <path
      d="M17.5 14.0625V13.125C17.5 12.8125 17.1875 12.5 16.875 12.5C16.5234 12.5 16.25 12.8125 16.25 13.125V14.0625C16.25 15.2734 15.2344 16.25 14.0625 16.25H13.125C12.7734 16.25 12.5 16.5625 12.5 16.875C12.5 17.2266 12.7734 17.5 13.125 17.5H14.0625C15.9375 17.5 17.5 15.9766 17.5 14.0625Z"
      fill="currentColor"
    />
    <path
      d="M6.25 0.625C6.25 0.3125 6.52344 0 6.875 0H10.625C10.9375 0 11.25 0.3125 11.25 0.625C11.25 0.976562 10.9375 1.25 10.625 1.25H6.875C6.52344 1.25 6.25 0.976562 6.25 0.625Z"
      fill="currentColor"
    />
  </svg>,
  "UpscaleImageIcon",
);
